'use client'

import React from 'react'
import Image from 'next/image'
import Dummy from '@/assets/industries/Infra & Construction.webp'
import { Row, Col, Container, Card } from 'react-bootstrap'
import { SlArrowDown, SlArrowRight } from 'react-icons/sl'
import Link from 'next/link'
import { ReactGAEvent } from '@/components/ReactGAs'
function CategorySection() {
	const items = [
		{
			id: 1,
			image: '/Ferrous.webp',
			title: 'Ferrous',
			subtitle: 'Mild Steel, Stainless Steel',
			backgroundColor: '#E1D3FA',
			link: 'mild-steel',
		},
		{
			id: 2,
			image: '/Metal_Recyclingstabel.webp',
			title: 'Metal Recycling',
			subtitle: 'Steel, Aluminium, Copper',
			backgroundColor: '#FFC7D1',
			link: 'ferrous-scrap',
		},
		{
			id: 3,
			image: '/Custom_Manufacturing.webp',
			title: 'Custom Manufacturing',
			subtitle: 'CNC Machining, Forging',
			backgroundColor: 'linear-gradient(180deg, #B6DFEC 0%, #BEEEFE 100%)',
			link: '',
		},
		{
			id: 4,
			image: '/Non-Ferrous.webp',
			title: 'Non-Ferrous',
			subtitle: 'Aluminium, Copper, Zinc, Nickel',
			backgroundColor: '#CCE8BE',
			link: 'aluminium',
		},
	]

	const viewMoreHandler = () => {
		ReactGAEvent({ action: 'View more click', event: 'View_more', label: 'Our categories', category: 'Categories' })
	}

	return (
		<>
			<Container className='category-section'>
				<Row className='category-section__header '>
					<div className='category-section__content'>
						<h2 className='category-section__title'>Our Products</h2>
						<p className='category-section__desc'>
							We serve and support diverse industries by delivering innovative solutions that enhance efficiency,{' '}
						</p>
					</div>

					<div className='image-grid-container'>
						{items.map((item) => (
							<Link key={item.id} href={`/products/${item?.link}`} className='grid-item'>
								<Image src={item.image} width={320} height={420} alt={item.title} className='grid-item-image' />
								<div className='grid-item-overlay'>
									<p className='grid-item-title'>{item.title}</p>
									<p className='grid-item-subtitle'>{item.subtitle}</p>
								</div>
							</Link>
						))}
					</div>
				</Row>
				<Link href={'../../products'} className='category-section__view-btn'>
					<button className='category-section__btn' onClick={viewMoreHandler}>
						<span className=''>View More </span>
						<SlArrowRight size='12' />
					</button>
				</Link>
			</Container>
		</>
	)
}

export default CategorySection
